import {
    GET_LINKS_TRACKING,
    GET_LINKS_TRACKING_SUCCESS
} from './constants';

/**
 *
 * @param quizLocalizationID
 * @returns {{type: string, quizLocalizationID: *}}
 */
const statisticsLinksTracking = (quizLocalizationID) => ({type: GET_LINKS_TRACKING,quizLocalizationID});

/**
 *
 * @param statistics
 * @returns {{type: string, statistics: *}}
 */
const statisticsLinksTrackingSuccess = statistics => ({type: GET_LINKS_TRACKING_SUCCESS, statistics});

export {
    statisticsLinksTracking,
    statisticsLinksTrackingSuccess
};